import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";

const MarketQualityAttributeAssignmentDateEditModal = ({
  show,
  onHide,
  onConfirm,
  field,
  oldValue,
  newValue,
  assignment,
}) => {
  const { t } = useTranslation(["markets"]);
  if (!field || !assignment) {
    return null;
  }

  const formatDate = (dateString) => {
    if (!dateString) return t("NotSet") || "Not Set";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch {
      return dateString;
    }
  };

  const fieldLabel =
    field === "startDate"
      ? t("StartDate") || "Start Date"
      : t("EndDate") || "End Date";

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("ConfirmDateChange") || "Confirm Date Change"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>
            {t("QualityAttributeValue") || "Quality Attribute Value"}:
          </strong>{" "}
          {assignment.qualityAttributeValue}
        </p>
        <p>
          <strong>{fieldLabel}</strong> {t("ChangeFrom") || "change from"}{" "}
          <strong>{formatDate(oldValue)}</strong> {t("To") || "to"}{" "}
          <strong>{formatDate(newValue)}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("Cancel") || "Cancel"}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {t("Confirm") || "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MarketQualityAttributeAssignmentDateEditModal;
